import { authFetch } from './authFetch';
import { handleUnauthorizedRedirect } from './authRedirect';

export interface ChatSendRequest {
  message: string;
  conversationId: number | null;
  sceneId?: number | null;
  currentFrame?: number | null;
}

export interface ChatSendResponse {
  id: string;
  role: string;
  content: string;
  timestamp: string;
  conversationId: number;
  conversationTitle: string | null;
}

export async function sendChatMessageDirect(
  movieId: number,
  body: ChatSendRequest
): Promise<ChatSendResponse | null> {
  const response = await authFetch(`/api/movies/${movieId}/chat/send`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (response.status === 401) {
    handleUnauthorizedRedirect();
    return null;
  }

  if (!response.ok) {
    console.error('[aiChatClient] send failed', response.status, await response.text());
    return null;
  }

  return (await response.json()) as ChatSendResponse;
}
